import {
  Center,
  Empty,
  EmptyDescription,
  EmptyHeadline,
  LockIcon,
} from '@frontend/legacy-components';

export type PaneNoAccessStateProps = {
  resourceLabel: string;
};

/**
 * Shown instead of a pane's data when the user has no access-granting
 * permission in any of their visible user groups (as opposed to an empty
 * result set, which uses each pane's own empty state).
 */
export const PaneNoAccessState = ({
  resourceLabel,
}: PaneNoAccessStateProps) => (
  <Center width="100%" height="100%" bg="page.background">
    <Empty size="md" py={3}>
      <LockIcon />
      <EmptyHeadline>No access</EmptyHeadline>
      <EmptyDescription>{`You don't have access to ${resourceLabel}.`}</EmptyDescription>
    </Empty>
  </Center>
);
